import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { OverviewInfoService } from './overview-info.service';
import { SharedService } from '../../../../../../../shared/services/share.services';
import { TMBDataTableComponent } from '../../../../../../../components/data-table/data-table.component';
import { OverviewInfo, MemberInfo } from '../../../../../../../models/group-template-information/overview-info';

@Component({
  selector: 'app-overview-info',
  templateUrl: './overview-info.component.html',
  providers: [OverviewInfoService, SharedService]
})
export class OverviewInfoComponent extends TMBDataTableComponent implements OnInit, OnChanges {
  overviewModel = new OverviewInfo();
  members = new Array<MemberInfo>();
  @Input() public groupId: string;
  @Input() public countries: Array<any>;
  @Input() isLoadedTab: boolean;
  constructor(private overviewService: OverviewInfoService,
    public sharedService: SharedService) {
    super(sharedService);
  }

  ngOnChanges() {
    if (this.isLoadedTab) {
      this.getOverview();
      this.setPage({ offset: 0 });
    }
  }

  ngOnInit() {

  }

  getOverview() {
    this.overviewService.getOverviewInfo(this.groupId).subscribe(res => {
      if (res) {
        const data = res.json();
        this.overviewModel = data;
        if (this.overviewModel) {
          this.overviewModel.countryName = this.countries.find(x => x.id === this.overviewModel.countryId).name;
        }
      }
    });
  }

  setPage(pageInfo) {
    if (this.groupId) {
      this.page.pageNumber = pageInfo.offset;
      const param = {
        pageSize: this.page.size,
        currentPage: this.page.pageNumber + 1
      };
      this.overviewService.getMembers(this.groupId, param).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.members = data['list'];
            this.page.totalElements = data['totalRecords'];
            this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-information-popup/group-template-information/overview-info/overview-info.component.ts